import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ModalWrapperContainer } from './ModalWrapper.styles';
/**
 * `ModalWrapper` wraps children components and presents them as a modal.
 *
 * @throws {Error} If `backdropClosesModal` is true but `closeModal` is undefined
 *
 * @public
 * @author Alex Kasemir
 */

var ModalWrapper =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(ModalWrapper, _Component);

  function ModalWrapper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleBackDropClick", function (e) {
      if (e.target !== e.currentTarget) return;

      _this.props.closeModal();
    });

    return _this;
  }

  var _proto = ModalWrapper.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        isOpen = _this$props.isOpen,
        children = _this$props.children,
        className = _this$props.className,
        backdropClosesModal = _this$props.backdropClosesModal;

    if (!isOpen) {
      return null;
    }

    return React.createElement(ModalWrapperContainer, {
      className: className || "",
      onClick: backdropClosesModal ? this.handleBackDropClick : null
    }, children);
  };

  return ModalWrapper;
}(Component);

ModalWrapper.defaultProps = {
  isOpen: true
};
export default ModalWrapper;